module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens19-5166feb06b1b4d0bed3e49e911625861.jpg";